import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const NotFoundPage = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to right, #1e3c72, #2a5298)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        textAlign: 'center',
      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={6} sx={{ p: 4, borderRadius: 4, backgroundColor: 'rgba(255,255,255,0.95)' }}>
          <ErrorOutlineIcon sx={{ fontSize: 80, color: '#f44336', mb: 2 }} />
          <Typography variant="h2" component="div" gutterBottom color="error">
            404
          </Typography>
          <Typography variant="h5" gutterBottom>
            Page non trouvée
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Désolé, la page que vous recherchez n'existe pas.
          </Typography>
          <Button
            component={Link}
            to="/"
            variant="contained"
            color="primary"
            size="large"
          >
            Retour à l'accueil
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default NotFoundPage;
